import styled from 'styled-components';
import giftGif from '../../../../assets/images/gift.gif';

// 全局样式覆盖，增强优先级
export const GlobalModalStyles = styled.div`
  .phone-verification-reward-modal {
    .ant-modal-content {
      background-color: #333 !important;
      padding: 0 !important;
      border-radius: 10px !important;
      overflow: hidden !important;
    }
    
    .ant-modal-body {
      padding: 0 !important;
      background-color: #333 !important;
    }
    
    .ant-modal-mask {
      background-color: rgba(0, 0, 0, 0.5) !important;
    }
  }
`;



export const PhoneVerificationRewardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const TopSection = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  position: relative;
  padding: 20px;
  background-color: #333;
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  padding: 40px 0; /* Add some padding to make space for the SVG */
`;

export const CongratsText = styled.p`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

export const PackageTitle = styled.h2`
  color: #fff;
  font-size: 30px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  margin: 5px 0;
`;

export const UnderlineSvg = styled.svg`
  width: 89.863px;
  height: 15.181px;
  flex-shrink: 0;
  position: absolute;
  bottom: 0;
  right: -50px;
  transform: translateX(-50%) rotate(4.637deg);
`;

export const GiftImage = styled.div`
  width: 80px;
  height: 80px;
  background: url(${giftGif}) no-repeat center center;
  background-size: contain;
`;



export const BottomSection = styled.div`
  height: 84px;
  background-color: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  flex-shrink: 0;
`;

export const RewardText = styled.p`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

export const HighlightNumber = styled.span`
  color: #ff6b35; /* 主题色 - 橙色 */
  font-weight: 600; /* 稍微加粗突出显示 */
`;

export const ActionButton = styled.button`
  width: 112px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  background: linear-gradient(123deg, #feae45 19.66%, #ff6d49 67.36%);
  border: none;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

export const ButtonIcon = styled.svg`
  width: 14px;
  height: 14px;
  flex-shrink: 0;
`;
